import { css, DefaultTheme, ThemedStyledProps } from 'styled-components';
import { BaseTypographyStyleProps } from './types';

const PROP_STYLEKEY_MAP: Record<keyof BaseTypographyStyleProps, string> = {
  $letterSpacing: 'letter-spacing',
  $align: 'text-align',
  $lineHeight: 'line-height',
  $textTransform: 'text-transform',
  $weight: 'font-weight',
};

const styleForProp =
  (prop: keyof BaseTypographyStyleProps) =>
  (props: ThemedStyledProps<BaseTypographyStyleProps, DefaultTheme>) => {
    const value = props[prop];

    if (!value) {
      return undefined;
    }

    return `${PROP_STYLEKEY_MAP[prop]}: ${value};`;
  };

export const baseStyles = css<BaseTypographyStyleProps>`
  ${Object.keys(PROP_STYLEKEY_MAP).map((value) =>
    styleForProp(value as keyof typeof PROP_STYLEKEY_MAP),
  )};
`;
